import React from 'react';

const Footer = () => {
  return (
    <footer className="text-gray-600 body-font">
      <div className="container-fluid px-5 py-8 flex items-center sm:flex-row flex-col bg-[#2e2e2e]">
        <a className="flex title-font font-medium items-center md:justify-start justify-center text-gray-900">
          <img 
            src="images/logo.jpeg" 
            className="w-10 h-10 text-white bg-grey-500 rounded-full" 
            alt="Prime Lawn Logo"
          />
          <span className="ml-3 text-xl text-white font-bold">Prime Holiday Lights</span>
        </a>
        
        <p className="text-sm text-white sm:ml-4 sm:pl-4 sm:border-l-2 sm:py-2 sm:mt-0 mt-4">
          Professional Christmas light installation in Barrie, Collingwood, Orillia, Innisfil, and surrounding regions. We design, install, and maintain commercial-grade holiday lighting for residential and commercial properties.
        </p>
        
        <span className="inline-flex sm:ml-auto sm:mt-0 mt-4 justify-center sm:justify-start">
          <a 
            className="text-white hover:text-yellow-300" 
            // href="https://www.facebook.com/prime.lawn.snow" 
            href='#'
            target="_blank" 
            rel="noopener noreferrer"
          >
            <svg 
              fill="currentColor" 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth="2" 
              className="w-8 h-8" 
              viewBox="0 0 24 24"
            >
              <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"></path>
            </svg>
          </a>

          <a 
            className="ml-4 text-white hover:text-yellow-300" 
            href="https://www.instagram.com/primeholidaylights" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            <svg 
              fill="none" 
              stroke="currentColor" 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth="2" 
              className="w-8 h-8" 
              viewBox="0 0 24 24"
            >
              <rect width="20" height="20" x="2" y="2" rx="5" ry="5"></rect>
              <path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37zm1.5-4.87h.01"></path>
            </svg>
          </a>
          
          <a 
            className="ml-4 text-white hover:text-yellow-300" 
            href="https://mail.google.com/mail/?view=cm&fs=1&to=primeholidaylights@gmail.com" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            <svg 
              fill="currentColor" 
              className="w-8 h-8" 
              viewBox="0 0 24 24"
            >
              <path d="M2 4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v.01L12 13 2 4.01V4zm0 2.236v13.764A2 2 0 0 0 4 22h16a2 2 0 0 0 2-2V6.236l-9.197 7.424a1 1 0 0 1-1.606 0L2 6.236z"/>
            </svg>
          </a>

          <a 
            className="ml-4 text-white hover:text-yellow-300" 
            // href="https://share.google/PAEvXkrYqtTPxzZyQ" 
            href='#'
            target="_blank" 
            rel="noopener noreferrer"
          >
            <svg 
              fill="currentColor" 
              className="w-10 h-9" 
              
              viewBox="0 0 24 24"
            >
              <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
            </svg>
          </a>
        </span>
      </div>
    </footer>
  );
};

export default Footer;